export default {
  evcs_order: {
    name: '第三方设备订单',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '订单号',
      evcs_operator: '平台商',
      charging_equipment: '充电设备接口',
      user: '用户',
      created_at: '开始充电时间',
      end_time: '结束充电时间',
      total_time: '总充电时长',
      consumed_minutes: '充电时长',
      total_power: '充电电量',
      total_money: '充电金额',
      ecmp_order_amount: '我方订单金额',
      amount_difference: '订单差价',
      stop_reason: '结束原因',
      charge_state: '状态'
    },
    // Enum的属性
    statuses: {
      starting: '启动中',
      charging: '充电中',
      stopping: '停止中',
      finished: '已结束',
      unavailable: '未知'
    },
    list_tabs: {
      all: '全部',
      starting: '启动中',
      charging: '充电中',
      stopping: '停止中',
      finished: '已结束',
      unavailable: '未知'
    },
    placeholder: {
      search_keyword: '请输入订单、接口编号',
      select_stop_reason: '请选择停止原因'
    },
    group_titles: {
      base: '基本信息',
      order_info: '账单信息',
      status_info: '计费信息',
      order_detail: '订单明细'
    },
    detail: {
      evcs_order_serial_number: '互联互通订单号',
      ecmp_trade_number: 'ECMP订单号',
      charge_station: '充电站',
      equipment: '设备',
      equipment_interface: '设备接口',
      electricity_fee: '电费',
      service_fee: '服务费'
    }
  }
}
